import { render, staticRenderFns } from "./MenuAdd.vue?vue&type=template&id=6f660f5e&scoped=true&"
import script from "./MenuAdd.vue?vue&type=script&lang=js&"
export * from "./MenuAdd.vue?vue&type=script&lang=js&"
import style0 from "./MenuAdd.vue?vue&type=style&index=0&id=6f660f5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f660f5e",
  null
  
)

export default component.exports